import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { FormHelperText, InputLabel, MenuItem } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { map } from "ramda";
import PropTypes from "prop-types";
import { getFieldOptionNames } from "../FieldOptions";
import { notBlank } from "../../util/ext";

const FieldOptionNameSelect = props => {
  const {
    onChange,
    value,
    error,
    helperText,
    onBlur,
    title = "Field Option Name",
    disabled = false,
  } = props;

  return (
    <FormControl fullWidth error={error}>
      <InputLabel htmlFor="field-option-name">{title}</InputLabel>
      <Select
        disabled={disabled}
        value={value || ""}
        onChange={onChange}
        SelectDisplayProps={{
          style: { fontSize: "1.8rem", lineHeight: "3.4rem" },
        }}
        inputProps={{
          name: "field-option-name",
          id: "field-option-name",
        }}
        error={error}
        onBlur={onBlur}
      >
        {map(fo => {
          return (
            <MenuItem value={fo.name} key={fo.name}>
              {fo.display}
            </MenuItem>
          );
        }, getFieldOptionNames())}
      </Select>
      {notBlank(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

FieldOptionNameSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default FieldOptionNameSelect;
